export default __webpack_public_path__ + "static/media/ipc-ing.f4132959.svg";